import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/home/index.vue'
import Chat from '@/views/chat/index.vue'
import Login from '@/views/login/index.vue'
import DevLogin from '@/views/login/dev-login.vue'
import Unauthorized from '@/views/error/unauthorized.vue'
import NotFound from '@/views/error/not-found.vue'

const router = createRouter({
  // history: createWebHashHistory(import.meta.env.BASE_URL),
  history: createWebHashHistory('/mobile/'),
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/login',
      meta: {
        unauthorized: true,
      },
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        unauthorized: true,
      },
    },
    {
      path: '/dev-login',
      name: 'dev-login',
      component: DevLogin,
      meta: {
        unauthorized: true,
      },
    },
    {
      path: '/401',
      name: 'unauthorized',
      component: Unauthorized,
      meta: {
        unauthorized: true,
      },
    },
    {
      path: '/404',
      name: 'not-found',
      component: NotFound,
      meta: {
        unauthorized: true,
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  // 路由变化时更新 CSP
  if (window.__DYNAMIC_CSP__) {
    const route = to.path;
    // console.log("路由变化时更新", route);
    window.__DYNAMIC_CSP__.updatePolicy(route);
  }

  // if (!window.location.pathname.startsWith('/mobile')) {
  //   console.log("xxxx", window.location.hash)
  //   // 如果不在/mobile路径下，重定向到/mobile/#/chat
  //   window.location.href = `/mobile${window.location.hash}`
  //   return
  // }

  if (!to.matched.length) {
    next({ name: 'not-found' })
  } else if (to.meta.unauthorized || sessionStorage.getItem('token')) {
    next()
  } else {
    next({ name: 'unauthorized' })
  }
})

export default router
